export default "__VITE_ASSET__DT4$UYQW__"